import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult({ success }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState(success ? "checking" : "cancelled");
  const attempts = useRef(0);

  useEffect(() => {
    if (!success) return;
    const sessionId = new URLSearchParams(location.search).get("session_id");
    if (!sessionId) {
      setStatus("error");
      return;
    }
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
      } catch {}
      attempts.current += 1;
      if (attempts.current < 10) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [success, location.search]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" data-testid="payment-result-page">
      <div className="bg-card rounded-2xl border border-brand-deep/10 p-10 max-w-md w-full text-center">
        {status === "checking" && (
          <>
            <Loader2 className="w-12 h-12 text-brand-deep animate-spin mx-auto" />
            <h1 className="font-display text-xl font-bold text-brand-dark mt-4">Mengesahkan bayaran...</h1>
            <p className="text-sm text-muted-foreground mt-2">Sila tunggu sebentar.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-brand-vivid mx-auto" data-testid="payment-success-icon" />
            <h1 className="font-display text-xl font-bold text-brand-dark mt-4">Bayaran Berjaya!</h1>
            <p className="text-sm text-muted-foreground mt-2">Langganan koperasi anda kini aktif.</p>
            <Link to="/admin" data-testid="payment-goto-admin" className="inline-block mt-6 bg-brand-deep text-white rounded-xl px-6 py-3 font-semibold hover:bg-brand-dark transition-colors">
              Ke Dashboard
            </Link>
          </>
        )}
        {(status === "timeout" || status === "error") && (
          <>
            <Loader2 className="w-12 h-12 text-gold mx-auto" />
            <h1 className="font-display text-xl font-bold text-brand-dark mt-4">Bayaran sedang diproses</h1>
            <p className="text-sm text-muted-foreground mt-2">Status akan dikemas kini sebentar lagi. Semak halaman Langganan.</p>
            <Link to="/admin/subscription" className="inline-block mt-6 bg-brand-deep text-white rounded-xl px-6 py-3 font-semibold hover:bg-brand-dark transition-colors">
              Semak Langganan
            </Link>
          </>
        )}
        {status === "cancelled" && (
          <>
            <XCircle className="w-12 h-12 text-red-400 mx-auto" data-testid="payment-cancel-icon" />
            <h1 className="font-display text-xl font-bold text-brand-dark mt-4">Bayaran Dibatalkan</h1>
            <p className="text-sm text-muted-foreground mt-2">Tiada caj dikenakan. Anda boleh cuba semula.</p>
            <button onClick={() => navigate("/admin/subscription")} data-testid="payment-retry-btn" className="mt-6 bg-brand-deep text-white rounded-xl px-6 py-3 font-semibold hover:bg-brand-dark transition-colors">
              Cuba Semula
            </button>
          </>
        )}
      </div>
    </div>
  );
}
